import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const TransformerEditorPage = lazy(
  () => import('~/features/transformers/pages/transformer-editor-page'),
);

/** Transformer editor — full-width (the platform layout skips its card nav for this path). */
export const Route = createFileRoute(
  '/_authenticated/_tenant/platform/transformers/$transformerId',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <TransformerEditorPage />
    </Suspense>
  ),
});
